import { render, staticRenderFns } from "./DetalheTituloReapresentacao.vue?vue&type=template&id=51607030&scoped=true"
import script from "./DetalheTituloReapresentacao.vue?vue&type=script&lang=js"
export * from "./DetalheTituloReapresentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51607030",
  null
  
)

export default component.exports